import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useSubscription } from '@/lib/contexts/SubscriptionContext'
import {
  SystemCardShell,
  SystemCardHeading,
  SystemCardActions,
  SystemCardPrimary,
  SystemCardSecondary,
} from '@/components/shared/layout'

export default function CheckoutSuccess() {
  const navigate = useNavigate()
  const { refreshSubscription, hasActiveTrial } = useSubscription()

  // If UnifiedOnboarding stashed a post-checkout destination, use it as the
  // primary CTA target so trial activators resume their onboarding flow.
  const resumeTarget = (() => {
    try { return sessionStorage.getItem('postCheckoutRedirect') } catch { return null }
  })()

  useEffect(() => {
    // Refresh subscription state so the rest of the app reflects the new plan immediately
    refreshSubscription()
  }, [refreshSubscription])

  const handlePrimary = () => {
    if (resumeTarget) {
      try { sessionStorage.removeItem('postCheckoutRedirect') } catch {
        // Ignore storage errors and continue navigation.
      }
      navigate(resumeTarget, { replace: true })
    } else {
      navigate('/onboarding')
    }
  }

  const highlights = [
    'All features on your plan are now active',
    'Data collection is running',
    hasActiveTrial ? 'Billing starts when the trial ends unless you cancel' : 'Your plan renews automatically',
  ]

  return (
    <SystemCardShell>
      <SystemCardHeading success eyebrow="Payment confirmed" title="You're all set">
        {hasActiveTrial ? 'Your trial is active.' : 'Your subscription is active.'} Welcome to Humblytics.
      </SystemCardHeading>

      <div className="flex flex-col gap-1 rounded-lg bg-canvas px-3.5 py-3">
        <p className="text-[13px] font-medium leading-5 text-foreground">What happens now</p>
        <ul className="flex flex-col gap-1">
          {highlights.map((item) => (
            <li key={item} className="text-xs leading-[18px] text-muted-foreground">{item}</li>
          ))}
        </ul>
      </div>

      <SystemCardActions>
        <SystemCardPrimary onClick={handlePrimary}>
          {resumeTarget ? 'Continue setup' : 'Set up your first test'}
        </SystemCardPrimary>
        <SystemCardSecondary onClick={() => navigate('/dashboard')}>Go to dashboard</SystemCardSecondary>
      </SystemCardActions>
    </SystemCardShell>
  )
}
